import { defineMessages } from "react-intl";

const messages = defineMessages({
  archive: {
    id: "settings.manageFields.grid.actions.archive",
    defaultMessage: "Archive",
    description: "Header of Archive Field action",
  },
  cancel: {
    id: "settings.manageFields.grid.actions.archive.cancel",
    defaultMessage: "Wait",
    description: "Cancel button title for archive action confirmation",
  },
  description: {
    id: "settings.manageFields.grid.actions.archive.confirm.description",
    defaultMessage:
      "<p>This field and its data will <b>no longer be accessible from the web or mobile application</b> and will be removed from any existing layouts.</p><p>However, all existing data will be preserved and the field can be unarchived at any point. The field and its data may also be modified from the API or any running integrations.</p><p>To permanently delete a field, you must first archive it.</p>",
    description: "Archive action confirmation text",
  },
  ok: {
    id: "settings.manageFields.grid.actions.archive.ok",
    defaultMessage: "I’m sure",
    description: "OK button title for archive action confirmation",
  },
  systemRequired: {
    id: "settings.manageFields.grid.actions.archive.systemRequired",
    defaultMessage: "Archiving of system required fields is not permitted",
    description: "Header of disabled Archive Field action for system required field",
  },
  title: {
    id: "settings.manageFields.grid.actions.archive.confirm.title",
    defaultMessage: "Are you sure you want to archive this field?",
    description: "Archive action confirmation text",
  },
  usedInWorkflow: {
    id: "settings.manageFields.grid.actions.archive.usedInWorkflow",
    defaultMessage:
      "This field is part of a workflow and cannot be archived. Please contact support if you’d like to archive or delete this field.",
    description: "Header of disabled Archive Field action for field used in workflow",
  },
});

export default messages;
